import { useEffect, useState } from "react";
import { useAuthStore, hasValidSession } from "./store/auth";
import LoginPage from "./views/LoginPage";
import Layout from "./components/Layout";
import ContractSigningPage from "./views/ContractSigningPage";
import WithdrawalPage from "./views/WithdrawalPage";
import WelcomePasswordScreen from "./views/WelcomePasswordScreen";

/**
 * Point d'entrée : consomme un éventuel jeton de lien magique présent dans
 * l'URL (`/auth/verify?token=…`), puis affiche l'espace connecté ou la page
 * de connexion.
 */
export default function App() {
  if (window.location.pathname === "/signer") return <ContractSigningPage />;
  // « Renoncer au contrat ici » : lien de l'e-mail de fin de signature, sans compte (vente à distance, T17).
  if (window.location.pathname === "/renoncer") return <WithdrawalPage />;
  return <AuthenticatedApp />;
}

function AuthenticatedApp() {
  const token = useAuthStore((s) => s.token);
  const candidate = useAuthStore((s) => s.candidate);
  const passwordStepSkipped = useAuthStore((s) => s.passwordStepSkipped);
  const verify = useAuthStore((s) => s.verify);
  const [consumingLink, setConsumingLink] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const magicToken = params.get("token");
    if (!magicToken) return;
    setConsumingLink(true);
    void verify(magicToken).finally(() => {
      // Nettoie l'URL (retire le jeton de la barre d'adresse et de l'historique).
      window.history.replaceState({}, "", window.location.pathname);
      setConsumingLink(false);
    });
  }, [verify]);

  if (consumingLink) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-light">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-primary-100 border-t-primary rounded-full animate-spin" />
          <p className="text-sm text-slate-500">Connexion en cours…</p>
        </div>
      </div>
    );
  }

  if (!hasValidSession({ token })) {
    return <LoginPage />;
  }
  // Accueil de l'espace élève (J3) : sans mot de passe, l'élève le choisit avant d'entrer (ou le remet à plus tard).
  if (candidate?.hasPassword === false && !passwordStepSkipped) {
    return <WelcomePasswordScreen />;
  }
  return <Layout />;
}
